<template>
  <el-dialog
    :model-value="dialogVisible"
    :title="dialogTitle"
    width="30%"
    @close="handleClose"
  >
    <el-form ref="formRef" :model="form" label-width="100px" :rules="rules">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <!-- <el-form-item label="图片" prop="image">
        <el-input v-model="form.image"></el-input>
      </el-form-item> -->
      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="产品id" prop="productId">
        <el-input v-model="form.productId"></el-input>
      </el-form-item>
      <el-form-item label="轮播图描述" prop="description">
        <el-input
          v-model="form.description"
          :rows="4"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfirm"
        >确认</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { defineEmits,ref ,defineProps,watch} from 'vue'
import axios from "@/util/axios";
import { ElMessage } from "element-plus";

const props=defineProps({
  dialogTitle:{
    type:String,
    default:'',
    required:true
  },
  id:{
    type:Number,
    default:-1,
    required:true
  }
})

const initFormData=async(id)=>{
  const res=await axios.get("admin/swiperImage/byId/"+id);
  form.value=res.data.data;
}

const form = ref({
  id:-1,
  name:'',
  sort: 0,
  image: "",
  productId: -1,
  description: ""
})

const resetFormValue = () => {
  form.value = {
    id:-1,
    name:'',
    sort: 0,
    image: "",
    productId: -1,
    description: ""
  };
};

watch(
  () => props.id,
  () => {
    if (props.id !== -1) {
      initFormData(props.id);
    }else {
      resetFormValue();
    }
  },
  { immediate: true }
);


const emits=defineEmits(['update:modelValue','initSwiperList',"resetId"])

const formRef=ref(null)

const handleClose = () => {
  emits('update:modelValue',false)
  emits('resetId')
  formRef.value.resetFields();
}


const rules=ref({
  name:[
    {
      required: true,
      message: '请输入轮播图名称！',
    }
  ]
})



const handleConfirm = () => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      try{

        let result=await axios.post("/admin/swiperImage/save",form.value);
        let data=result.data;
        if(data.code==0){
          ElMessage.success("执行成功");
          formRef.value.resetFields();
          emits("initSwiperList")
          handleClose();
        }else{
          ElMessage.error(data.msg);
        }
      }catch(err){
        console.log("error:"+err)
        ElMessage.error('系统运行出错，请联系管理员');
      }
    } else {
      return false
    }
  })
}
</script>

<style scoped>

</style>